const styles = {
  root: {
    '& .product': {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
      borderRadius: 8,
    },
  },
};

export default styles;
